import { Component } from 'react';
import CancelationModal from './CancelationModal';

class Cancelation extends Component {
    constructor(props) {
        super(props);

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.state = {
            isOpenModal: false,
        };
    }

    onOpenModal() {
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    render() {
        return (
            <>
                <div className="change-plan-cancelation" id="change-plan-cancelation">
                    <div className="change-plan-cancelation-left">
                        <img src="/static/img/alert-triangle.svg" alt="icon" />
                    </div>
                    <div className="change-plan-cancelation-right">
                        <div className="change-plan-cancelation-right-inner">
                            <div className="change-plan-cancelation-header">
                                Cancel Subscription
                            </div>
                            <div className="change-plan-cancelation-subheader">
                                Cancel your subscription and retain access until the end of the
                                current billing period.
                                <br />
                                This action removes access after your period ends
                            </div>
                        </div>
                        <div>
                            <button onClick={this.onOpenModal}>Cancel subscription</button>
                        </div>
                    </div>
                </div>
                <CancelationModal
                    isOpenModal={this.state.isOpenModal}
                    onCloseModal={this.onCloseModal}
                />
            </>
        );
    }
}

export default Cancelation;
